const languageDisplayNames = new Intl.DisplayNames(["en"], {
  type: "language",
});

export function getLanguageName(code: string): string {
  try {
    const baseCode = code.split("-")[0];
    return languageDisplayNames.of(baseCode) || code;
  } catch {
    return code;
  }
}
